import { render } from "./PaymentsStatistic.vue?vue&type=template&id=413891cf"
import script from "./PaymentsStatistic.vue?vue&type=script&lang=js"
export * from "./PaymentsStatistic.vue?vue&type=script&lang=js"

import "./PaymentsStatistic.vue?vue&type=style&index=0&id=413891cf&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__